var _path, _path2, _circle, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7996 25H5.19956C4.39956 25 3.69956 24.6 3.29956 23.9C2.89956 23.2 2.99956 22.4 3.39956 21.7L4.49956 20C6.29956 17.3 7.19956 14.2 7.19956 11C7.19956 7.3 9.59956 3.9 13.0996 2.7C13.6996 1.6 14.7996 1 15.9996 1C17.1996 1 18.2996 1.6 18.8996 2.7C22.3996 3.9 24.7996 7.3 24.7996 11C24.7996 14.2 25.6996 17.3 27.4996 20L28.5996 21.7C28.9996 22.4 29.0996 23.2 28.6996 23.9C28.3996 24.6 27.5996 25 26.7996 25Z",
    fill: "#6E7191"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0996 27C11.5996 29.3 13.5996 31 15.9996 31C18.3996 31 20.3996 29.3 20.8996 27H11.0996Z",
    fill: "#6E7191"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 7,
    r: 6,
    fill: "#6E7191",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.661 5.492H20.204V7.088C20.3113 6.93867 20.47 6.81733 20.68 6.724C20.89 6.626 21.1163 6.577 21.359 6.577C21.7463 6.577 22.0613 6.65867 22.304 6.822C22.5467 6.98067 22.7193 7.18833 22.822 7.445C22.9293 7.697 22.983 7.96533 22.983 8.25C22.983 8.586 22.92 8.887 22.794 9.153C22.668 9.419 22.4743 9.629 22.213 9.783C21.9563 9.937 21.6367 10.014 21.254 10.014C20.764 10.014 20.3673 9.888 20.064 9.636C19.7607 9.384 19.5763 9.048 19.511 8.628H20.134C20.1947 8.894 20.323 9.10167 20.519 9.251C20.715 9.40033 20.9623 9.475 21.261 9.475C21.6297 9.475 21.9073 9.36533 22.094 9.146C22.2807 8.922 22.374 8.628 22.374 8.264C22.374 7.9 22.2807 7.62 22.094 7.424C21.9073 7.22333 21.632 7.123 21.268 7.123C21.0207 7.123 20.8037 7.18367 20.617 7.305C20.435 7.42167 20.302 7.58267 20.218 7.788H19.616V4.932H22.661V5.492Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.fcf61eff02881336dd9c05d5ca6092bb.svg";
export { ForwardRef as ReactComponent };